import { render, staticRenderFns } from "./tableOccurrence.vue?vue&type=template&id=e99f448e&"
import script from "./tableOccurrence.js?vue&type=script&lang=js&"
export * from "./tableOccurrence.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports